import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { PHONE_HREF, PHONE_DISPLAY } from "@/data/site";

export const StickyCall = () => (
  <motion.a
    data-testid="sticky-call-button"
    href={PHONE_HREF}
    aria-label={`Ligar para ${PHONE_DISPLAY}`}
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.4, type: "spring", stiffness: 260, damping: 18 }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.94 }}
    className="fixed bottom-6 right-6 z-[95] call-pulse group flex items-center gap-0 hover:gap-3 bg-[#C2185B] hover:bg-[#A2134B] text-white rounded-full shadow-2xl shadow-[#C2185B]/40 px-4 py-4 transition-all duration-300"
  >
    <Phone size={22} strokeWidth={2.4} className="shrink-0" />
    <span className="max-w-0 group-hover:max-w-[140px] overflow-hidden whitespace-nowrap font-semibold text-sm transition-all duration-400">
      {PHONE_DISPLAY}
    </span>
  </motion.a>
);
